<template>
  <div class>


    <sweet-modal ref="modal" width="900px" hide-close-button blocking>


        <p class="popup-save-title">{{ this.$t('ct-title-upgrade-popup') }}</p>
        <p  v-if="isFree == 1" class="popup-save-message">
         {{ this.$t('ct-message-upgrade-popup') }}
        </p>
        <div  v-if="isFree == 1" class="button-container">
          <button @click="upgradeClick()" class="btn btn-primary btn-lg popup-save-btn-upgrade">
            {{ this.$t('ct-button-upgrade-popup') }}
          </button>
        </div>

        <hr>


      <button slot="button" class="btn btn-outline-danger mt-2 btn-not-now" @click="close"> {{ this.$t('ct-not-now-tks') }}</button>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
export default {
  props: ['isFree', 'show', 'url_upgrade'],
  name: 'ModalSave',
  components: {
    SweetModal
  },
  data() {
    return {
      step: 1,
    };
  },
  watch: {
    show: function(value) {
      if (value)
        this.$refs.modal.open();
      else
        this.$refs.modal.close();
    }
  },
  methods: {
    close() {
        this.$emit('closeAction');
         this.$refs.modal.close();
    },

    upgradeClick(){
      var win = window.open(this.url_upgrade, '_blank');
      win.focus();
      this.$emit('upgradeClick');
      this.close();

    },

    publishClick(){
      console.log('clicou em publicar');
    },

  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>




</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalSave.vue